import { memo } from 'react';

import Admin from './Admin';

export const AdminContainer = () => {
  return <Admin />;
};

export default memo(AdminContainer);
